/** @format */

import api from "../../../utils/api";
import { referenceService } from "../constant";
import {
  getCache,
  setCache,
  removeCacheByPrefix,
} from "../../../utils/cacheHelper";
const basePath = `${referenceService}`;

/** get All SNP By Activated */
export const getSnp = async (): Promise<any> => {
  const cached = getCache("snp");
  if (cached) return cached;

  try {
    const response = await api.get(`${basePath}/snp`, {
      params: {
        activated: 1,
      },
    });
    const data = response?.data?.return;
    if (data) setCache("snp", data);
    return data;
  } catch (error) {
    console.log(error);
  }
};

/** Post SNP  */
export const postSnp = async (params: any) => {
  const response = await api.post(`${basePath}/snp`, params);
  removeCacheByPrefix("snp");
  return response?.data?.return;
};

/** Post SNP  */
export const deleteSnp = async (params: any) => {
  const response = await api.delete(`${basePath}/snp/${params}`);
  removeCacheByPrefix("snp");
  return response?.data?.return;
};

/** Get Kegiatan  */
export const getKegiatanSnp = async (): Promise<any> => {
  const cached = getCache("kegiatan-snp");
  if (cached) return cached;

  const response = await api.get(`${basePath}/kegiatan-snp`, {
    params: {
      activated: 1,
    },
  });
  const data = response?.data?.return;
  if (data) setCache("kegiatan-snp", data);
  return data;
};

/** Post Kegiatan  */
export const postKegiatanSnp = async (params: any) => {
  const response = await api.post(`${basePath}/kegiatan-snp`, params);
  removeCacheByPrefix("kegiatan-snp");
  return response?.data?.return;
};

/** Delete Kegiatan  */
export const deleteKegiatanSnp = async (params: any) => {
  const response = await api.delete(`${basePath}/kegiatan-snp/${params}`);
  removeCacheByPrefix("kegiatan-snp");
  return response?.data?.return;
};

/** Get Sub Kegiatan  */
export const getSubKegiatan = async (): Promise<any> => {
  const cached = getCache("sub-kegiatan");
  if (cached) return cached;

  const response = await api.get(`${basePath}/sub-kegiatan`, {
    params: {
      activated: 1,
    },
  });
  const data = response?.data?.return;
  if (data) setCache("sub-kegiatan", data);
  return data;
};

/** Post Sub Kegiatan  */
export const postSubKegiatan = async (params: any) => {
  const response = await api.post(`${basePath}/sub-kegiatan`, params);
  removeCacheByPrefix("sub-kegiatan");
  return response?.data?.return;
};

/** Delete Sub Kegiatan  */
export const deleteSubKegiatan = async (params: any) => {
  const response = await api.delete(`${basePath}/sub-kegiatan/${params}`);
  removeCacheByPrefix("sub-kegiatan");
  return response?.data?.return;
};
